<template>
  <div>
    <vs-popup title="AUTENTICAÇÂO API BUSINESS" :active.sync="isPopupActive" v-on:close="closeCallback" class="sizePopup">
      <div class="w-full">
        <div class="w-full flex justify-center items-center pt-4 pb-4">
          <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span">Token Permanente Meta:</span>
            </div>

            <vs-input
                v-if="instance"
                class="w-full"
                v-model="instance.official_token"
            />
          </div>
        </div>

        <div class="w-full flex justify-center items-center pt-4 pb-4">
          <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span text-center">Identificação da conta do WhatsApp Business:</span>
            </div>

            <vs-input
                v-if="instance"
                class="w-full"
                v-model="instance.waba_id"
            />
          </div>
        </div>
      </div>

      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">

          <div class="vs-con-loading__container" id="button-loading-reset">
            <vs-button
              color="rgb(62, 201, 214)"
              type="filled"
              class="align-right"
              @click.prevent="getConnectedPhones"
            >
              <span>Buscar Telefones Conectados</span>
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="SELECIONAR NÚMERO PARA VINCULAR" :active.sync="numberPopup" class="top-component">
      <vs-table
        ref="transferTicketTable"
        noDataText="Nenhum usuário online"
        pagination
        :data="phoneNumbers"
      >
        <template slot="thead">
          <vs-th>Nome</vs-th>
          <vs-th>Telefone</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium" @click.prevent="confirmPhoneNumber(tr)">
                {{ tr.display_name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate" @click.prevent="confirmPhoneNumber(tr)">
                {{ tr.phone_number }}
              </p>
            </vs-td>

          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>

import { default as instanceApis } from '@/http/requests/instance'
import { default as whatsappApis } from '@/http/requests/whatsapp'
import moduleInstance from '@/store/instance/moduleInstance'
import Vue from '@/main'
import { getCurrentTenant } from '@/utils'
// import { initFacebookSdk } from '@/utils/facebookConnect'

export default({
  data(){
    return {
      wppQrCode: null,
      open: false,
      numberPopup: false,
      phoneNumbers: []
    }
  },
  props: ['isPopupActive', 'closeCallback'],
  methods: {
    async launchWhatsAppSignup() {
      // Conversion tracking code
      // fbq && fbq('trackCustom', 'WhatsAppOnboardingStart', {
      //   appId: this.facebookAppId,
      //   feature: 'whatsapp_embedded_signup'
      // });

      // const FB = await initFacebookSdk()

      // Launch Facebook login
      // FB.login(function (response) {
      //   if (response.authResponse) {
      //     const accessToken = response.authResponse.accessToken;
      //     console.log(accessToken);
      //     //Use this token to call the debug_token API and get the shared WABA's ID
      //   } else {
      //     console.log('User cancelled login or did not fully authorize.');
      //   }
      // }, {
      //   scope: 'public_profile,business_management,whatsapp_business_management,whatsapp_business_messaging',
      //   extras: {
      //     feature: 'whatsapp_embedded_signup',
      //     version: 2
      //   }
      // });
    },
    async confirmPhoneNumber(selectedNumber) {
      this.instance.phone_number = selectedNumber.phone_number
      this.instance.messaging_limit = selectedNumber.messaging_limit
      this.instance.official_phone_id = selectedNumber.official_phone_id
      this.instance.messaging_send = selectedNumber.business_initiated_conversations
      await instanceApis.update(this.instance)
      this.numberPopup = false
      this.$vs.notify({
        color: 'success',
        title: 'Vinculação completa!',
        text: `Configuração de conexão com a meta completada!`,
        time: 8000
      })
      this.closeCallback()
    },
    async getConnectedPhones() {
      const instance = (await instanceApis.update(this.instance)).data.data.updateInstance
      try {
        this.phoneNumbers = (await whatsappApis.getOfficialPhoneNumbers(instance.id)).data.data.getOfficialPhoneNumbers
        this.numberPopup = true;
      } catch (error) {
        if (JSON.parse(error.request.response).errors[0].code === 401) {
          this.$vs.notify({
            color: 'danger',
            title: 'Token inválido!',
            text: `Os tokens fornecidos são inválidos ou estão expirados`,
            time: 8000
          })
        }
      }
    }
  },
  created() {  
    if (!moduleInstance.isRegistered) {
      this.$store.registerModule('instance', moduleInstance)
      moduleInstance.isRegistered = true
    }

    Vue.$events.on('InstanceUpdated', (event) => {
      if (
       this.instance
       && !event.isOnboarding
       && event.instance.activated
       && event.tenantName === getCurrentTenant()
       && this.instance.id === event.instance.id
      ) {
          this.closeCallback();
      }
    })
  },
  computed: {
    facebookAppId() {
      return process.env.VUE_APP_FACEBOOK_APP_ID;
    },
    instance() {
      return this.$store.state.instance.selectedInstanceObject 
    }
  }
})
</script>

<style type="text/css">
  .top-component {
    z-index: 9999999999;
  }
</style>